import { JSX } from "react";

import { Box, Divider, Typography, useTheme } from "@mui/material";
import { isMobile } from "react-device-detect";
import LangBox from "src/components/TopNav/components/LangBox";
import Profile from "src/components/TopNav/components/Profile/Profile";
import images from "src/constants";

const styles = {
  header: (open: boolean) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    px: 1,
    py: 2,
    flexDirection: open ? "row" : "column-reverse",
  }),
  logoBox: (open: boolean) => ({ height: 32, width: 32, pt: open ? 0 : 2, display: "flex", alignItems: "center" }),
  mobileLogoContainer: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, width: "100%" },
  mobileLogoContent: { display: "flex", alignItems: "center", justifyContent: "start", gap: 1 },
  mobileLangBox: { px: 1 },
};

function SidebarHeader({ open }: { open: boolean }): JSX.Element {
  const theme = useTheme();

  return (
    <>
      <Box sx={styles.header(open)}>
        {!isMobile && (
          <Box sx={styles.logoBox(open)} gap={1}>
            <img src={images.logo} width={32} height={32} alt='DiamondApp' />
            <Typography variant='h4'>Diamond App</Typography>
          </Box>
        )}

        {isMobile && (
          <>
            <Box sx={styles.mobileLogoContainer}>
              <Box sx={styles.mobileLogoContent}>
                <Box>
                  <img width={32} height={32} src={images.logo} alt='Diamond App' />
                </Box>
                <Typography lineHeight={1} fontSize={theme.fontSizes.lg} fontWeight={theme.typography.fontWeightRegular}>
                  {" "}
                  Diamond App
                </Typography>
              </Box>
              <Profile />
            </Box>
            <Divider />
          </>
        )}
      </Box>
      {isMobile && (
        <Box sx={styles.mobileLangBox}>
          <LangBox />
        </Box>
      )}
    </>
  );
}

export default SidebarHeader;
